// import { API_URL, API_URL_SUFFIX } from "@/constants/api";
// import { extractProps } from "@/utils/api";
import { pharmacyClient } from "@/connect";
import { Level, PharmacySize } from "@/gen/auth/common_pb";
import { CategoryWiseDistribution, ExpiryRiskTimeline, HealthScore, InventoryValueTrend, StockStatusDistribution, TopSupplier } from "@/gen/inventory/common_pb";
import { TransferHistoryResponse } from "@/gen/inventory/transfer_history_pb";
import { ListPurchaseInvoicesResponse } from "@/gen/purchase_invoice/list_purchase_invoices_pb";
import { ListPurchaseOrdersResponse } from "@/gen/purchase_order/list_purchase_orders_pb";
import { ListPurchaseRequestsResponse } from "@/gen/purchase_request/list_purchase_requests_pb";
import { Loading } from "@/layouts/loading";
import Component from "@/routes/company/_layout/inventory/-components/index";
import { createFileRoute } from "@tanstack/react-router";
import { InventoryOverviewSchema } from "./-data/model";

type Props = {
    inventory_overview: InventoryOverviewSchema;
    top_suppliers: TopSupplier[];
    expiry_timeline: ExpiryRiskTimeline[];
    stock_status_split: StockStatusDistribution[];
    health_scores: HealthScore;
    non_medical_category_distribution: CategoryWiseDistribution[];
    inventory_trend: InventoryValueTrend[];
    purchase_orders?: ListPurchaseOrdersResponse;
    purchase_invoices?: ListPurchaseInvoicesResponse;
    purchase_requests?: ListPurchaseRequestsResponse;
    inventory_transfers?: TransferHistoryResponse;
}
export const Route = createFileRoute("/company/_layout/inventory/")({
    component: Component,
    loader: async (): Promise<Props> => {
        const inventoryOverview = await pharmacyClient.inventoryOverview({});

        const pharmacySize = localStorage.getItem('pharmacySize')

        if (pharmacySize === PharmacySize.SIZE_SMALL.toString()) {
            const inventoryOverviewData = inventoryOverview.branchLevelView
            return {
                inventory_overview: {
                    total_inventory_count: inventoryOverviewData?.totalItems!,
                    total_inventory_value: inventoryOverviewData?.totalInventoryValue!,
                    out_of_stock_count: inventoryOverviewData?.outOfStockItems!,
                    expiring_soon_count: inventoryOverviewData?.expiringSoonItems!,
                },
                top_suppliers: inventoryOverviewData?.topSuppliers!,
                expiry_timeline:  inventoryOverviewData?.expiryRiskTimeline!,
                stock_status_split: inventoryOverviewData?.stockStatusDistribution!,
                health_scores: inventoryOverviewData?.healthScore!,
                non_medical_category_distribution: inventoryOverviewData?.categoryWiseDistribution!,
                inventory_trend: inventoryOverviewData?.inventoryValueTrends!
            }
        } else {
            const level = localStorage.getItem('level')
            if (level === Level.BRANCH.toString()) {
                let purchaseOrders, purchaseInvoices, purchaseRequests, inventoryTransfers;
                const inventoryOverviewData = inventoryOverview.branchLevelView
                purchaseOrders = await pharmacyClient.listPurchaseOrders({
                    pageNumber: 1,
                    pageSize: 2,
                });
                purchaseInvoices = await pharmacyClient.listPurchaseInvoices({
                    pageNumber: 1,
                    pageSize: 2,
                });
                purchaseRequests = await pharmacyClient.listPurchaseRequests({
                    page: 1,
                    pageSize: 2,
                });
                inventoryTransfers = await pharmacyClient.transferHistory({
                    pageNumber: 1,
                    pageSize: 2,
                })
                return {
                    inventory_overview: {
                        total_inventory_count: inventoryOverviewData?.totalItems!,
                        total_inventory_value: inventoryOverviewData?.totalInventoryValue!,
                        out_of_stock_count: inventoryOverviewData?.outOfStockItems!,
                        expiring_soon_count: inventoryOverviewData?.expiringSoonItems!,
                    },
                    top_suppliers: inventoryOverviewData?.topSuppliers!,
                    expiry_timeline:  inventoryOverviewData?.expiryRiskTimeline!,
                    stock_status_split: inventoryOverviewData?.stockStatusDistribution!,
                    health_scores: inventoryOverviewData?.healthScore!,
                    non_medical_category_distribution: inventoryOverviewData?.categoryWiseDistribution!,
                    inventory_trend: inventoryOverviewData?.inventoryValueTrends!,
                    purchase_orders: purchaseOrders,
                    purchase_invoices: purchaseInvoices,
                    purchase_requests: purchaseRequests,
                    inventory_transfers: inventoryTransfers
                }
            } else if (level === Level.STOCK_POINT.toString()) {
                const inventoryOverviewData = inventoryOverview.stockPointLevelView
                return {
                    inventory_overview: {
                        total_inventory_count: inventoryOverviewData?.totalItems!,
                        total_inventory_value: inventoryOverviewData?.totalInventoryValue!,
                        out_of_stock_count: inventoryOverviewData?.outOfStockItems!,
                        expiring_soon_count: inventoryOverviewData?.expiringSoonItems!,
                    },                    
                    top_suppliers: inventoryOverviewData?.topSuppliers!,
                    expiry_timeline:  inventoryOverviewData?.expiryRiskTimeline!,
                    stock_status_split: inventoryOverviewData?.stockStatusDistribution!,
                    health_scores: inventoryOverviewData?.healthScore!,
                    non_medical_category_distribution: inventoryOverviewData?.categoryWiseDistribution!,
                    inventory_trend: inventoryOverviewData?.inventoryValueTrends!
                }
            } else if (level === Level.COMPANY.toString()) {
                const inventoryOverviewData = inventoryOverview.companyLevelView
                return {
                  inventory_overview: {
                    total_inventory_count: inventoryOverviewData?.totalItems!,
                    total_inventory_value: inventoryOverviewData?.totalInventoryValue!,
                    out_of_stock_count: inventoryOverviewData?.outOfStockItems!,
                    expiring_soon_count: inventoryOverviewData?.expiringSoonItems!,
                  },
                  top_suppliers: inventoryOverviewData?.topSuppliers!,
                    expiry_timeline:  inventoryOverviewData?.expiryRiskTimeline!,
                    stock_status_split: inventoryOverviewData?.stockStatusDistribution!,
                    health_scores: inventoryOverviewData?.healthScore!,
                    non_medical_category_distribution: inventoryOverviewData?.categoryWiseDistribution!,
                    inventory_trend: inventoryOverviewData?.inventoryValueTrends!,
                    purchase_orders: undefined,
                    purchase_invoices: undefined,
                    purchase_requests: undefined,
                    inventory_transfers: undefined
                }
            } else {
              throw new Error("Invalid Auth")
            }
        }
    },
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1
});